var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4162 7.36386L12.365 23.4139C12.1792 23.5996 11.9588 23.747 11.7161 23.8475C11.4734 23.9481 11.2133 23.9998 10.9506 23.9998C10.6879 23.9998 10.4278 23.9481 10.1851 23.8475C9.94244 23.747 9.72195 23.5996 9.53622 23.4139L0.583722 14.4139C0.209315 14.0389 -0.000976562 13.5306 -0.000976562 13.0007C-0.000976562 12.4708 0.209315 11.9626 0.583722 11.5876L3.58372 8.58761C3.95751 8.21373 4.46412 8.00306 4.9928 8.00165C5.52148 8.00025 6.0292 8.20823 6.40497 8.58011L10.985 12.9889L10.9987 13.0026L22.59 1.58136C22.9648 1.2081 23.4722 0.998535 24.0012 0.998535C24.5302 0.998535 25.0376 1.2081 25.4125 1.58136L28.4125 4.52636C28.5998 4.712 28.7486 4.93285 28.8502 5.1762C28.9518 5.41956 29.0043 5.68061 29.0047 5.94433C29.005 6.20806 28.9532 6.46925 28.8522 6.71287C28.7512 6.95649 28.6031 7.17774 28.4162 7.36386Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1a7497eb5b23ebb55253b7a2f55c8113.svg";
export { ForwardRef as ReactComponent };